import styled from 'styled-components';
import IconChevronDownOutline from './IconChevronDownOutline';
var IconChevronLeftOutline = /*#__PURE__*/styled(IconChevronDownOutline).withConfig({
  displayName: "IconChevronLeftOutline",
  componentId: "c11n-8-111-1__sc-hujn6u-0"
})(["transform:rotate(90deg);"]);
export default IconChevronLeftOutline;